var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"https://wa.link/cx7v4b"}},[_c('img',{attrs:{"src":require("../../assets/svg/Wapp.svg"),"alt":""}})])
}]

export { render, staticRenderFns }